import * as THREE from 'three';
import {
  CARD1Web
} from '../CoordUtils.js';

import {BaseDrawer} from "@/drawings3D/modelDrawing/BaseDrawer"
import { LaneDividerLine } from '@/drawings3D/models/LaneDividerLine'
import { LaneDividerLineDrawer } from '@/drawings3D/modelDrawing/LaneDividerLineDrawer'
export class FenceDrawer {
	constructor(fenceData, sceneManager){
		this.offsetX = sceneManager.CoordOffset.lat;
		this.offsetZ = sceneManager.CoordOffset.lon;
		this.sceneManager = sceneManager;
		this.fenceData = fenceData;
		this.fenceMaterial = new THREE.MeshBasicMaterial({
      		color: 0xff0000,
      		transparent:true,
      		opacity:0.1
    	});
	}

	draw(){
		var minY = -30;
		var maxY = 30;

		//test
		this.fenceData.coord.map(item=>{
			var geometry1 = new THREE.SphereGeometry( 1, 10, 10 );
	    	var material1 = new THREE.MeshBasicMaterial( {color: 0xff0000} );
	    	var sphere1 = new THREE.Mesh( geometry1, material1 );
	    	this.sceneManager.scene.add( sphere1 );
	    	sphere1.position.copy(new THREE.Vector3(item.lat  - this.offsetX,  minY, item.lon - this.offsetZ));
		});

		this.fenceData.coord.map(item=>{
			var geometry1 = new THREE.SphereGeometry( 1, 10, 10 );
	    	var material1 = new THREE.MeshBasicMaterial( {color: 0xff0000} );
	    	var sphere1 = new THREE.Mesh( geometry1, material1 );
	    	this.sceneManager.scene.add( sphere1 );
	    	sphere1.position.copy(new THREE.Vector3(item.lat  - this.offsetX,  maxY, item.lon - this.offsetZ));
		});

    	
		var vertices = [];
		this.fenceData.coord.map(item=>{
			vertices.push(new THREE.Vector3(item.lat  - this.offsetX,  minY, item.lon - this.offsetZ));
		});

		this.fenceData.coord.map(item=>{
			vertices.push(new THREE.Vector3(item.lat  - this.offsetX,  maxY, item.lon - this.offsetZ));
		});
		
		
		var verticeLength = vertices.length / 2;
		var faces = [];
		for (var i = 0; i < verticeLength - 1; i++){
			 faces.push(new THREE.Face3(i, i + verticeLength,  i + 1, null, null, 1));
			 faces.push(new THREE.Face3(i + 1, i + verticeLength, i + verticeLength + 1, null, null, 1));
		}

		//闭合点
		faces.push(new THREE.Face3(verticeLength - 1, 2 * verticeLength - 1,  0, null, null, 1));
		faces.push(new THREE.Face3(0, 2 * verticeLength - 1, verticeLength, null, null, 1));

		//围栏两面都可见
		for (var i = 0; i < verticeLength - 1; i++){
			 faces.push(new THREE.Face3(i + 1, i + verticeLength,  i, null, null, 1));
			 faces.push(new THREE.Face3(i + verticeLength + 1, i + verticeLength, i + 1, null, null, 1));
		}

		//闭合点
		faces.push(new THREE.Face3(0, 2 * verticeLength - 1,  verticeLength - 1, null, null, 1));
		faces.push(new THREE.Face3(verticeLength, 2 * verticeLength - 1, 0, null, null, 1));

		var geom = new THREE.Geometry();
    	geom.vertices = vertices;
    	geom.faces = faces;
		var  mesh = new THREE.Mesh(geom, this.fenceMaterial);
		this.sceneManager.scene.add( mesh );

	}
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/FenceDrawer.js